var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center pointer"},[_c('e-svg-icon',_vm._b({},'e-svg-icon',_vm.icon.attrs,false),[_vm._v(_vm._s(_vm.icon.name))]),_c('span',{class:_vm.textClass,style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }